import axios from '@/libs/api.request'

/**
 * 检查分类名称是否重复
 */
export const checkName = (name, pid) => {
    const data ={
        "name": name,
        "pid": pid
    }
    return axios.request({
        url: '/api/admin/goodscate/check',
        data,
        method: 'post'
    })
}

/**
 * 商品分类树数据
 */
export const goodsCatData = () => {
    return axios.request({
        url: '/api/admin/goodscate/tree',
        method: 'post'
    })
}

/**
 * 设置直播状态
 */
export const setLivingState = (is_living) => {
    const data ={
        "is_living": is_living
    }
    return axios.request({
        url: '/api/admin/goods/setLivingState',
        data,
        method: 'post'
    })
}